import React, { useState, useEffect, useRef } from 'react';

// 스크롤 시 Fade-in 효과를 위한 커스텀 훅
export default function useFadeIn(options){
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      }, options);
  
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        if (ref.current) {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          observer.unobserve(ref.current);
        }
      };
    }, [ref, options]);
  
    return [ref, isVisible];
  };